'use client';
import { useSyncExternalStore } from 'react';
import {
  BIO_ANALYTICS_PREFERENCE_EVENT,
  bioAnalyticsDisabled,
  disableBioAnalytics,
} from '@/lib/link-in-bio/analytics-preference';
import { Button } from '@mantine/core';

function subscribe(onChange: () => void) {
  window.addEventListener(BIO_ANALYTICS_PREFERENCE_EVENT, onChange);
  window.addEventListener('storage', onChange);
  return () => {
    window.removeEventListener(BIO_ANALYTICS_PREFERENCE_EVENT, onChange);
    window.removeEventListener('storage', onChange);
  };
}

export function AnonymousAnalyticsPreference() {
  const disabled = useSyncExternalStore(subscribe, bioAnalyticsDisabled, () => false);
  return (
    <section
      id="anonymous-analytics"
      aria-label="Anonymous analytics"
      className="mt-12 scroll-mt-8"
    >
      <h2 className="text-xl font-semibold text-white mb-3">Anonymous analytics</h2>
      <p className="text-zinc-300 mb-4">
        We use visit and click counts to improve these pages. You can turn off anonymous measurement
        in this browser.
      </p>
      <Button
        type="button"
        disabled={disabled}
        onClick={() => {
          disableBioAnalytics();
        }}
      >
        {disabled ? 'Anonymous analytics are off' : 'Turn off anonymous analytics'}
      </Button>
    </section>
  );
}
